import { Container, createStyles, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useAppDialog } from "../app-dialog";
import { FamilyValues } from "../family-values";
import { FinancialValues } from "../financial-values";
import { ProfileItemModel } from "../models/profile-item.model";
import { SpiritualValues } from "../spiritual-values";
import { EdSlider } from "../ui/ed-slider";
import { useStorage } from "../utils/use-storage";
import { ProfileItem } from "./profile-item";


type Props = {

}

const items: ProfileItemModel[] = [{
    id: 1,
    name: 'Ayana',
    sex: 'F',
    age: 29,
    city: 'Toronto, Canada',
    goals: [
        'Finish law school',
    ],
    picture: 'https://images.unsplash.com/photo-1613126539059-a0cbf4862e62?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cG9ydHJhaXQlMjBwaWN0dXJlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
}, {
    id: 2,
    age: 27,
    sex: 'M',
    name: 'George',
    city: 'Toronto, Canada',
    goals: [
        'Buy a home in the suburbs',
    ],
    picture: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHBvcnRyYWl0JTIwcGljdHVyZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
}, {
    id: 3,
    age: 32,
    sex: 'F',
    name: 'Kate',
    city: 'Toronto, Canada',
    goals: [
        'Have a family with 2-3 kids',
        'Start a private medical practice'
    ],
    picture: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8cG9ydHJhaXQlMjBwaWN0dXJlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
}, {
    id: 4,
    age: 35,
    sex: 'M',
    name: 'Ben',
    city: 'Toronto, Canada',
    goals: [
        'Work on my business',
        'Meet someone who appreciates my sense of humor'
    ],
    picture: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHBvcnRyYWl0JTIwcGljdHVyZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
}, {
    id: 5,
    age: 25,
    sex: 'F',
    name: 'Daniella',
    city: 'Toronto, Canada',
    goals: [
        'Run a marathon',
    ],
    picture: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDZ8fHBvcnRyYWl0JTIwcGljdHVyZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
}];

const Key = 'Profiles'

export const Profiles = (props: Props) => {
    const classes = useStyles({});
    const app_dialog = useAppDialog();
    const [liked, setLiked] = React.useState<{ [id: number]: boolean }>({});

    const _items = React.useMemo(() => items.map(i => {
        const random_1 = Math.floor(Math.random() * FamilyValues.length / 3);
        const random_2 = Math.floor(Math.random() * FamilyValues.length / 3 + FamilyValues.length / 3);
        const random_3 = Math.floor(Math.random() * FamilyValues.length / 3 + FamilyValues.length / 3 * 2);

        const random_4 = Math.floor(Math.random() * FinancialValues.length / 3);
        const random_5 = Math.floor(Math.random() * FinancialValues.length / 3 + FinancialValues.length / 3);
        const random_6 = Math.floor(Math.random() * FinancialValues.length / 3 + FinancialValues.length / 3 * 2);

        const random_7 = Math.floor(Math.random() * SpiritualValues.length / 2);
        const random_8 = Math.floor(Math.random() * SpiritualValues.length / 2 + SpiritualValues.length / 2);
        return {
            ...i,
            family_values: [
                FamilyValues[random_1],
                FamilyValues[random_2],
                FamilyValues[random_3],
            ],
            financial_values: [
                FinancialValues[random_4],
                FinancialValues[random_5],
                FinancialValues[random_6],
            ],
            spiritual_values: [
                SpiritualValues[random_7],
                SpiritualValues[random_8],
            ]
        }
    }), [])

    const onLike = (item: ProfileItemModel) => {
        if (Object.keys(liked).length === 0) {
            app_dialog.showDialog({
                title: 'Your First Crush ❤️',
                message: 'Once you like a personality card you can see their profile picture. If you match, we will open a conversation between you both.',
                buttons: [
                    {label: 'Gotcha!',}
                ],
            })
        }
        setLiked(l => ({
            ...l,
            [item.id]: true,
        }));
        

    }

    const renderItem = (item: ProfileItemModel) => {
        return <ProfileItem item={item} is_liked={liked[item.id]} onLike={() => onLike(item)} />
    }

    return (
        <div className={classes.section}>
            <Container maxWidth='lg'>
                <Typography gutterBottom
                    variant='h3' align='center'>How does <strong>Flutter</strong> Work?</Typography>
                <Typography gutterBottom variant='h6' align='center'>
                    Our profiles focus on showcasing your personality first. <br />Here are some examples,
            tap the like button on a profile that resonnates with you <span role='img'>❤️</span>.
                    </Typography>
                <EdSlider
                    items={_items}
                    no_infinite
                    partially_visible
                    renderItem={renderItem} />
            </Container>
        </div>
    );

}

const useStyles = makeStyles(theme => createStyles({
    section: {
        paddingBottom: theme.spacing(4),
    }
}))